import { HStack, Stack } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import ProceedCancelButtons from "components/Button/ProceedCancelButtons";
import { FloatingField } from "design-system";
import { newHireSchema, NewHireFormValues } from "./definitions";

interface NewHireFormProps {
  onClose: () => void;
  onSubmit: (data: NewHireFormValues) => void;
  isLoading: boolean;
  proceedText: string;
  defaultValues: Partial<NewHireFormValues>;
  excludedUserIds?: string[];
}

export default function NewHireFormFields({
  onClose,
  defaultValues,
  onSubmit,
  isLoading,
  proceedText,
  excludedUserIds = [],
}: NewHireFormProps) {
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setFocus,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(newHireSchema),
    defaultValues,
  });

  useEffect(() => {
    setFocus("firstName");
  }, [setFocus]);

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues, reset]);

  return (
    <>
      <Stack gap={2.5}>
        <FloatingField name="firstName" errors={errors.firstName?.message} required>
          <FloatingField.Label>First Name</FloatingField.Label>
          <FloatingField.Text control={control} name="firstName" />
        </FloatingField>
        <FloatingField name="lastName" errors={errors.lastName?.message} required>
          <FloatingField.Label>Last Name</FloatingField.Label>
          <FloatingField.Text control={control} name="lastName" />
        </FloatingField>
        <FloatingField name="startDate" errors={errors.startDate?.message} required>
          <FloatingField.Label>Start Date</FloatingField.Label>
          <FloatingField.Calendar control={control} name="startDate" />
        </FloatingField>
        <FloatingField name="title" errors={errors.title?.message} required>
          <FloatingField.Label>Job Title</FloatingField.Label>
          <FloatingField.Text control={control} name="title" />
        </FloatingField>
        <FloatingField name="personalEmail" errors={errors.personalEmail?.message} required>
          <FloatingField.Label>Personal Email</FloatingField.Label>
          <FloatingField.Text control={control} name="personalEmail" />
        </FloatingField>
      </Stack>
      <HStack mt={12} justify="end">
        <ProceedCancelButtons
          handleSubmit={handleSubmit(onSubmit)}
          onClose={onClose}
          proceedText={proceedText}
          isLoading={isLoading}
        />
      </HStack>
    </>
  );
}
